import { css } from '@emotion/core';
import { variables, aNormalize } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
import { expandClickZone } from '../common.style';
var colour = variables.colour,
  font = variables.font;
export var listingCard = /*#__PURE__*/css("position:relative;display:flex;flex-wrap:nowrap;background-color:", colour.white, ";max-width:100%;");
export var image = {
  name: "13993l3",
  styles: "width:415px;height:385px;object-fit:cover;"
};
export var infoSection = {
  name: "x8b3kr",
  styles: "flex-grow:1;padding:0 5px;display:flex;flex-direction:column;align-items:center;text-align:center;overflow:hidden;"
};
export var title = /*#__PURE__*/css("font-family:", font.headingFontFamily, ";font-weight:600;font-size:", font.smallFontSize, ";line-height:18px;color:", colour.accent, ";border-bottom:2px solid ", colour.accent, ";padding-bottom:12px;margin-top:30px;");
export var listingInfo = /*#__PURE__*/css(typography.bodyLongNoLinks, " color:", colour.neutral700, ";display:flex;flex-direction:column;margin-top:40px;width:100%;");
export var price = /*#__PURE__*/css(typography.headingM, " line-height:28px;");
export var addressContainer = /*#__PURE__*/css(aNormalize, " max-width:100%;", expandClickZone);
export var addressLine = {
  name: "b00fp5",
  styles: "display:inline-block;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;max-width:100%;"
};
export var featureGroup = {
  name: "ehcz25",
  styles: "margin-top:25px;display:flex;gap:10px;justify-content:center;"
};
export var feature = {
  name: "1dnaxzp",
  styles: "display:flex;align-items:center;gap:5px;"
};
export var featureText = /*#__PURE__*/css(typography.bodyBold);
export var agentInfo = {
  name: "vfsjyv",
  styles: "margin-top:30px;display:flex;gap:5px;justify-content:center;"
};
export var agentDetails = {
  name: "1gnc3qn",
  styles: "display:flex;flex-direction:column;gap:5px;"
};
export var agentName = /*#__PURE__*/css(typography.bodySmall, " line-height:14px;");
export var agentPhoto = {
  name: "ocs6nn",
  styles: "height:46px;width:46px;"
};
export var agencyLogo = {
  name: "12zccz6",
  styles: "width:100px;height:25px;object-fit:contain;object-position:left;"
};